export default "__VITE_PUBLIC_ASSET__4726eaa3__"